module.exports = __webpack_public_path__ + "static/img/payments.3a248d1.gif";